import React, { Component } from "react";

import LoginForm from "./LoginForm";
import ResetarSenha from "./ResetarSenha";
import AlterarSenha from "./AlterarSenha";

import "./css/login.css";

class Login extends Component {
  render() {
    return (
      <div className="container-scroller">
        <div className="container-fluid page-body-wrapper full-page-wrapper">
          <div className="content-wrapper d-flex align-items-center auth auth-bg-1 theme-one">
            <div className="row w-100 mx-auto">
              <div className="col-lg-4 mx-auto">
                <div className="login-logo-container animated fadeIn">
                  <img src="/images/login-logo.png" alt="" />
                </div>
                <div className="auto-form-wrapper">
                  <LoginForm />
                  <div className="text-block text-center my-3">
                    <span
                      data-toggle="modal"
                      data-target="#esqueceu-senha-modal"
                      className="text-small forgot-password link"
                    >
                      Esqueci minha senha
                    </span>
                  </div>
                </div>
                <p className="footer-text text-center">
                  {`Copyright © ${new Date().getFullYear()} X-Brain. Todos os direitos reservados.`}
                </p>
              </div>
            </div>
          </div>
        </div>
        <ResetarSenha />
        <AlterarSenha />
      </div>
    );
  }
}

export default Login;
